import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'

import { cn } from '@/lib/cn'

function General({
  label,
  className,
  children,
  withoutControl = false,
  ...props
}: React.ComponentProps<typeof FormItem> & {
  label: React.ReactNode
  withoutControl?: boolean
}) {
  return (
    <FormItem className={cn('space-y-1', className)} {...props}>
      <FormLabel>{label}</FormLabel>
      {withoutControl ? children : <FormControl>{children}</FormControl>}
      <FormMessage />
    </FormItem>
  )
}

export const FormItemTemplate = {
  General,
}
